/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Overlay} from "@angular/cdk/overlay";

import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";

import {SessionService} from "../../../platform/base/services/session.service";

import {BaseProfileComponent} from "../base/base-profile.component";
import {TranslateService} from "@ngx-translate/core";

import {GuestsService} from "../../guests/guests.service";
import {Guests2Service} from "../../guests2/guests2.service";

/**
 * todo
 */
@Component({
	selector: 'app-company',
	templateUrl: './company.component.html',
	styleUrls: ['../profile.component.css']
})

export class CompanyComponent extends BaseProfileComponent implements OnInit {

	public description: string;
	public friends: string[] = [];
	public mails: string[] = [];

	public height: number;
	public experience: number;
	public score: number;
	public driver: number;
	public seveniron: number;
	public rounds: number;
	public practice: number;
	public handicap: number;

	constructor(
		protected session: SessionService,
		protected overlay: Overlay,
		protected accountService: GuestsService,
		//protected accountService: Guests2Service, // todo:guests2
		protected matDialog: MatDialog,
		protected snackbar: MatSnackBar,
		protected router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session, overlay, accountService, matDialog, snackbar, router, route, translate);
	}

	/**
	 * @params content
	 * @returns none
	 */
	public override readFrom(content: any): void {

		this.type = content.type;

		this.description = content.description;
		this.friends = content.friends;
		this.mails = content.mails;

		this.height = content.height;
		this.experience = content.experience;
		this.score = content.score;
		this.driver = content.driver;
		this.seveniron = content.seveniron;
		this.rounds = content.rounds;
		this.practice = content.practice;
		this.handicap = content.handicap;
	}

	/**
	 * @returns content
	 */
	public override writeTo(body: any): void {
		body.height = this.height;
		body.experience = this.experience;
		body.score = this.score;
		body.driver = this.driver;
		body.seveniron = this.seveniron;
		body.rounds = this.rounds;
		body.practice = this.practice;
		body.handicap = this.handicap;
	}

	/**
	 * @returns none
	 */
	public onChangeManage(): void {
		if (this.manage?.user_id) {
			this.accountService.relation_from_user(this.manage.user_id, "belongs", {}, (error, all_companies) => {
				if (!error) {
					this.companies = this.difference(all_companies, this.selected_companies);
				} else {
					this.errorDialog(error);
				}
			});
		}
	}

}
